module.exports = __webpack_public_path__ + "img/pusha.66073be0.jpg";